import React, { useState, useEffect } from "react";

function LatestNews() {
  const [newsItems, setNewsItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch news items from public/utils/newsItems.json
    const fetchNews = async () => {
      try {
        const response = await fetch('/utils/newsItems.json');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setNewsItems(data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching news items:', error);
        setError(`Failed to load news: ${error.message}`);
        setLoading(false);
        // Set empty array as fallback to prevent rendering errors
        setNewsItems([]);
      }
    };
    
    fetchNews();
  }, []);

  if (loading) {
    return <div>Loading news...</div>;
  }

  if (error) {
    return <div>Error loading news: {error}</div>;
  }

  // Filter out empty news items
  const validNewsItems = newsItems.filter(news => news.text && news.text.trim() !== "");

  // If no valid news items, show a message
  if (!loading && !error && validNewsItems.length === 0) {
    return (
      <div className="news-container heading-section mt-4">
        <h2 className="mb-3 fs-1">Latest News & <span>Events</span> </h2>
        <div className="news-wrapper">
          <div className="news-content">
            <div className="news-item">No news items available at the moment.</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="news-container heading-section mt-4">
      <h2 className="mb-3 fs-1">Latest News & <span>Events</span> </h2>
      <div className="news-wrapper">
        <div className="news-content">
          {/* Show content once, scroll, pause, then repeat */}
          {validNewsItems.length > 0 && validNewsItems.map((news, index) => (
            news.link ? (
              <a 
                key={index} 
                href={news.link} 
                className="news-item"
                target={news.target || "_self"}
                rel={news.target === "_blank" ? "noreferrer" : undefined}
              >
                {news.text}
              </a>
            ) : (
              <div key={index} className="news-item">
                {news.text}
              </div>
            )
          ))}
        </div>
      </div>
    </div>
  );
}

export default LatestNews;
